export { RatingComponent } from './rating.component';
export { RatingModule } from './rating.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
